<template>
  <!-- เมนูกระบวนงาน — แก้รายการเมนูที่ adminProcessMenus.js (managerTransfer) -->
  <AdminProcessNav v-bind="menu" />
</template>

<script>
import AdminProcessNav from "./AdminProcessNav.vue";
import { ADMIN_MENUS } from "./adminProcessMenus";

export default {
  name: "HRvecTransferenceManagebar",
  components: { AdminProcessNav },
  data() {
    return { menu: ADMIN_MENUS.managerTransfer };
  }
};
</script>
